import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ProfileComponent } from './profile/profile.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ImagesComponent } from './images/images.component';
import { AdvertisingComponent } from './advertising/advertising.component';
import { UserComponent } from './user/user.component';
import { ContractComponent } from './contract/contract.component';
import { BranchesComponent } from './branches/branches.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { RolesComponent } from './roles/roles.component';
import { permissionsGuard } from './permissions/guards/permissions.guard';
import { rolesGuard } from './roles/guards/roles.guard';
import { profileGuard } from './profile/guards/profile.guard';
import { branchesRoutes } from './branches/branches.routes';
import { advertisingRoutes } from './advertising/advertising.routes';
import { contractRoutes } from './contract/contract.routes';
import { imagesRoutes } from './images/images.routes';
import { permissionsRoutes } from './permissions/permissions.routes';
import { rolesRoutes } from './roles/roles.routes';
import { profileRoutes } from './profile/profile.routes';
import { userRoutes } from './user/user.routes';
import { TurnComponent } from './turn/turn.component';
import { turnRoutes } from './turn/turn.routes';
import { ServiciosComponent } from './servicios/servicios.component';
import { serviciosRoutes } from './servicios/servicios.routes';
import { QueueAlertsComponent } from './queue-alerts/queue-alerts.component';
import { queueAlertsRoutes } from './queue-alerts/queue-alerts.routes';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: DashboardComponent, canActivate: [profileGuard, rolesGuard, permissionsGuard], },
      { path: 'advertising', component: AdvertisingComponent, canActivate: [profileGuard, rolesGuard],
        children: advertisingRoutes,
      },
      { path: 'branch', component: BranchesComponent, canActivate: [profileGuard, rolesGuard],
        children: branchesRoutes,
      },
      { path: 'contract', component: ContractComponent, canActivate: [profileGuard, rolesGuard],
        children: contractRoutes,
      },
      { path: 'image', component: ImagesComponent, canActivate: [profileGuard, rolesGuard],
        children: imagesRoutes
      },
      { path: 'permission', component: PermissionsComponent, canActivate: [profileGuard, rolesGuard],
        children: permissionsRoutes
      },
      { path: 'role', component: RolesComponent, canActivate: [profileGuard, rolesGuard],
        children: rolesRoutes
      },
      { path: 'profile', component: ProfileComponent, children: profileRoutes },
      { path: 'user', component: UserComponent, canActivate: [profileGuard, rolesGuard],
        children: userRoutes
      },
      { path: 'turn', component: TurnComponent, canActivate: [profileGuard, rolesGuard],
        children: turnRoutes
      },
      { path: 'servicios', component: ServiciosComponent, canActivate: [profileGuard, rolesGuard],
        children: serviciosRoutes,
      },
      { path: 'queue-alerts', component: QueueAlertsComponent, canActivate: [profileGuard, rolesGuard],
        children: queueAlertsRoutes,
      }
    ],
  },
  {path: '**', redirectTo: ''},
];
